__turbopack_context__.v({
  "ButtonsWrapper": "NKXASa_ButtonsWrapper",
  "Cell--Scaled": "NKXASa_Cell--Scaled",
  "Description": "NKXASa_Description",
  "DownloadButton": "NKXASa_DownloadButton",
  "Export": "NKXASa_Export",
  "FullscreenInner": "NKXASa_FullscreenInner",
  "FullscreenOverlay": "NKXASa_FullscreenOverlay",
  "Root": "NKXASa_Root",
  "Root--FirstColAndRowAreHeaders": "NKXASa_Root--FirstColAndRowAreHeaders",
  "Root--FirstColIsHeader": "NKXASa_Root--FirstColIsHeader",
  "Root--HasScroll": "NKXASa_Root--HasScroll",
  "ScrollContainer": "NKXASa_ScrollContainer",
  "ScrollContainerFull": "NKXASa_ScrollContainerFull",
  "Table": "NKXASa_Table",
  "Table--Export": "NKXASa_Table--Export",
  "TableWrapper": "NKXASa_TableWrapper",
  "Title": "NKXASa_Title",
  "TitleWrapper": "NKXASa_TitleWrapper",
  "skeleton-loading": "NKXASa_skeleton-loading",
});
